<template>
    <div data-scroll-to-active="true" class="main-menu menu-fixed menu-dark menu-accordion menu-shadow">

      <!--<div class="main-menu-header">
        <input type="text" placeholder="Search" class="menu-search form-control round"/>
      </div>-->

      <div class="main-menu-content">
        <ul id="main-menu-navigation" data-menu="menu-navigation" class="navigation navigation-main">
          
          <li class="nav-item open" @click="collapseMenu()">
            <router-link :to="{ name: 'dashboard'}">
              <i class="icon-home3"></i>
              <span class="menu-title">{{ $t('titles.dashboard')}}</span>
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.getDispatcher || $store.getters.getAdmin" @click="collapseMenu()">
              <router-link :to="{ name: 'users'}">
                <i class="icon-users2"></i>
                <span class="menu-title">{{ $t('titles.users')}}</span>
              </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.getClient || $store.getters.getDispatcher || $store.getters.getAdmin || $store.getters.getService" @click="collapseMenu()">
            <router-link :to="{ name: 'tasks'}">
              <i class="icon-clipboard2"></i>
              <span class="menu-title">{{ $t('titles.tasksList') }}</span>
            </router-link>
          </li>

          <li class="nav-item" @click="collapseMenu()" v-if="!$store.getters.getService">
            <router-link :to="{ name: 'appeals'}">
              <i class="icon-bubble2"></i>
              <span class="menu-title">{{ $t('titles.problem') }}</span>
            </router-link>
          </li>

          <li class="nav-item" @click="collapseMenu()" v-if="!$store.getters.getService"> 
            <router-link :to="{ name: 'equipment'}">
              <i class="icon-office"></i><span class="menu-title">{{ $t('titles.equipment')}}</span>
            </router-link>
          </li>

          <li class="nav-item" @click="collapseMenu()"> 
            <router-link :to="{ name: 'activation'}">
              <i class="icon-add_to_queue"></i><span class="menu-title">{{ $t('titles.activation')}}</span>
            </router-link>
          </li>
          
          <!-- <li class="nav-item has-sub" v-if="$store.getters.getClient || $store.getters.getDispatcher || $store.getters.getAdmin">
            <a>
              <i class="icon-office"></i>
              <span class="menu-title">{{ $t('titles.equipment')}}</span>
            </a>
            <ul class="menu-content">
              <li class="nav-item">
                <router-link :to="{ name: 'equipment'}">
                  <i class="icon-office"></i><span class="menu-title">{{ $t('titles.eq1')}}</span>
                </router-link>
              </li>
              <li class="nav-item" v-if="$store.getters.getAdmin">
                <router-link :to="{ name: 'product'}">
                  <i class="icon-box-remove"></i><span class="menu-title">{{ $t('titles.eq2')}}</span>
                </router-link>
              </li>
            </ul>
          </li> -->

        </ul>
      </div>

    </div>
</template>
<script>

    export default {
      name: "Sidebar",
      data() {
        return {
          
        }
      },
      methods: {
        collapseMenu(){
          if(($.app.menu.expanded) && $('body').hasClass('vertical-overlay-menu')){
            $.app.menu.toggle();
          }
        },
      },
      computed:{},
      mounted(){
               
      },
      created(){
        /*let self = this;
        setTimeout(function(){
          document.getElementById('equipmentLink').addEventListener('click',function(){ self.$router.push({ name: 'equipment'}); } );
          document.getElementById('extEqLink').addEventListener('click',function(){ self.$router.push({ name: 'product'}); } );
        },1000); */
      }
    }

</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/menu/Sidebar.vue